import { jsxs as k, jsx as o, Fragment as A } from "react/jsx-runtime";
import { Y as x, F as D, am as P, an as j, ao as W, ap as O, aq as F, ar as Y, E as $, D as q, as as K, at as U, au as E, av as V, aw as I, ax as N } from "../../TabGroup-B4jOGf3W.js";
import { aU as Fe, b2 as Ee, bY as ze, bZ as Ge, b_ as Le, b$ as He, bf as Ae, az as je, c0 as Oe, c1 as Ye, c2 as $e, c4 as qe, b4 as Ke, b5 as Ue, bs as Ve, aD as Je, aE as Qe, b6 as Xe, b9 as Ze, ba as _e, bJ as et, aA as tt, aB as at, aC as st, bt as nt, bI as lt, bb as ot, bc as it, ct as rt, co as ct, cp as dt, bB as ut, bD as mt, bE as bt, bF as pt, bd as ht, bv as ft, bx as gt, bw as Ct, bK as St, bj as yt, br as Tt, b7 as xt, b8 as kt, bA as Bt, bP as It, bQ as Nt, bT as vt, aW as Dt, aX as Pt, aF as wt, aG as Mt, aM as Rt, aN as Wt, aJ as Ft, aK as Et, aH as zt, aI as Gt, be as Lt, aL as Ht, bU as At, bV as jt, bW as Ot, bX as Yt, c7 as $t, aQ as qt, aR as Kt, cq as Ut, cr as Vt, cs as Jt, cu as Qt, cv as Xt, cg as Zt, cd as _t, cc as ea, ci as ta, ch as aa, cb as sa, ce as na, cf as la, ca as oa, c5 as ia, aS as ra, bn as ca, bq as da, bp as ua, bm as ma, bo as ba, aV as pa, aY as ha, b1 as fa, a_ as ga, ay as Ca, b3 as Sa, c9 as ya, ck as Ta, bu as xa, bC as ka, bi as Ba, cj as Ia, bS as Na, bR as va, bG as Da, bz as Pa, c8 as wa, c3 as Ma, bN as Ra, bh as Wa, bg as Fa, bk as Ea, bl as za, bH as Ga, bO as La, bL as Ha, cn as Aa, a$ as ja, aP as Oa, aT as Ya, cl as $a, by as qa, bM as Ka, aO as Ua, cm as Va, c6 as Ja, b0 as Qa, aZ as Xa } from "../../TabGroup-B4jOGf3W.js";
import { Component as J, useMemo as T } from "react";
import { Range as Q, Set as v } from "immutable";
import "fast-levenshtein";
import "fuzzy";
import { s as y } from "../../timing-BFaISC6B.js";
import "fast-deep-equal";
import { c as z } from "../../references-BRMYEcTr.js";
import { createPortal as X } from "react-dom";
import "@tanstack/react-virtual";
import "clsx";
import "tailwind-merge";
import "lucide-react";
import "@radix-ui/react-checkbox";
import "luxon";
import "react-day-picker";
import "radix-ui";
import "@radix-ui/react-switch";
import { u as L } from "../../multiselect-U-cZqL-s.js";
const Z = "rounded-full inline-flex items-center relative z-0 min-w-0";
function ke({
  children: n,
  backgroundColor: t,
  color: i,
  className: h,
  innerRef: u,
  style: m,
  size: r = "small",
  leftContent: C,
  rightContent: S,
  ...a
}) {
  const g = x(n), e = x(C), d = x(S);
  return /* @__PURE__ */ k(
    "div",
    {
      className: D(
        {
          [Z]: !0,
          "py-[8px]": r === "large",
          "py-[4px]": r === "small",
          "py-0": r === "x-small"
        },
        h
      ),
      ref: u,
      style: {
        color: i,
        backgroundColor: t,
        paddingLeft: y(r, {
          large: () => 8 + (e ? 22 : 0),
          small: () => 8 + (e ? 22 : 0),
          "x-small": () => 6 + (e ? 14 : 0)
        }),
        paddingRight: y(r, {
          large: () => 8 + (d ? 22 : 0),
          small: () => 8 + (d ? 22 : 0),
          "x-small": () => 6 + (d ? 14 : 0)
        }),
        ...m
      },
      ...a,
      children: [
        e && /* @__PURE__ */ o(
          "div",
          {
            className: "absolute top-1/2 -translate-y-1/2",
            style: {
              left: y(r, {
                large: () => 8,
                small: () => 8,
                "x-small": () => 6
              }),
              width: y(r, {
                large: () => 16,
                small: () => 16,
                "x-small": () => 12
              }),
              height: y(r, {
                large: () => 16,
                small: () => 16,
                "x-small": () => 12
              })
            },
            children: e
          }
        ),
        /* @__PURE__ */ o(
          P,
          {
            as: "div",
            color: "inherit",
            type: y(r, {
              large: () => "Body/L/Bold",
              small: () => "Body/M/Bold",
              "x-small": () => "Body/S/Bold"
            }),
            className: typeof g == "string" ? "truncate" : void 0,
            title: typeof g == "string" ? g : void 0,
            children: g
          }
        ),
        d && /* @__PURE__ */ o(
          "div",
          {
            className: "absolute top-1/2 -translate-y-1/2",
            style: {
              right: y(r, {
                large: () => 8,
                small: () => 8,
                "x-small": () => 6
              }),
              width: y(r, {
                large: () => 16,
                small: () => 16,
                "x-small": () => 12
              }),
              height: y(r, {
                large: () => 16,
                small: () => 16,
                "x-small": () => 12
              })
            },
            children: d
          }
        )
      ]
    }
  );
}
class Be extends J {
  state = {
    caught: null
  };
  componentDidCatch(t, i) {
    this.setState({
      caught: {
        error: t,
        info: i
      }
    }), this.props.onError ? this.props.onError?.(t, i) : console.error(t, i);
  }
  render() {
    return /* @__PURE__ */ o(A, { children: this.state.caught ? x(this.props.errorChildren, {
      ...this.state.caught,
      reset: () => this.setState({ caught: null })
    }) : this.props.children });
  }
}
const _ = {
  info: "Information",
  warning: "Icon-full-alert",
  error: "Icon-full-error",
  success: "Icon-full-ok"
};
function Ie({
  severity: n,
  children: t,
  position: i = "top",
  align: h = "endToEnd",
  mode: u = "hover",
  overrideIcon: m,
  overrideColor: r,
  autoCloseTimeout: C = 100,
  innerRef: S,
  iconSize: a,
  overrideIconColor: g,
  disabled: e,
  hideArrow: d,
  ...s
}) {
  return /* @__PURE__ */ o(
    j,
    {
      disabled: e,
      innerRef: S,
      autoCloseTimeout: C,
      mode: u,
      position: i,
      align: h,
      overrideColor: r ?? W[n],
      severity: n,
      hideArrow: d,
      trigger: (l) => /* @__PURE__ */ o(
        O,
        {
          innerRef: l.innerRef,
          icon: m ?? _[n],
          color: g ?? r ?? W[n],
          size: a
        }
      ),
      ...s,
      children: t
    }
  );
}
function Ne({ className: n, style: t, show: i, children: h, ...u }) {
  return X(
    /* @__PURE__ */ o(F.Consumer, { children: ({ zIndex: m }) => /* @__PURE__ */ o(
      ee,
      {
        show: i,
        className: n,
        style: { position: "fixed", zIndex: m, ...t },
        ...u,
        children: /* @__PURE__ */ o(F.Provider, { value: { zIndex: m + 1 }, children: x(h, { show: i }) })
      }
    ) }),
    document.body
  );
}
function ee({
  className: n,
  style: t,
  show: i,
  children: h,
  innerRef: u,
  ...m
}) {
  return /* @__PURE__ */ o(
    Y,
    {
      in: i,
      className: $(
        "inset-0 transition-opacity flex flex-col items-center justify-center",
        n
      ),
      enterFromClassName: "opacity-0",
      enterToClassName: "opacity-100",
      unmountOnExit: !0,
      children: ({ className: r }) => /* @__PURE__ */ o(
        "div",
        {
          className: q(r),
          style: {
            position: "absolute",
            zIndex: 10,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            ...t
          },
          ...m,
          ref: u,
          children: x(h, { show: i })
        }
      )
    }
  );
}
function ve({
  onClick: n,
  onMouseEnter: t,
  onMouseLeave: i,
  className: h,
  style: u,
  children: m,
  wrapperAppearance: r,
  innerRef: C,
  ...S
}) {
  return /* @__PURE__ */ k(
    "div",
    {
      ref: C,
      style: r?.style,
      className: D("relative z-0", r?.className),
      ...S,
      children: [
        /* @__PURE__ */ o("div", { className: D("relative z-0", h), style: u, children: x(m) }),
        n && /* @__PURE__ */ o(
          "button",
          {
            type: "button",
            onClick: n,
            onMouseEnter: t,
            onMouseLeave: i,
            "aria-label": "clickable area",
            className: "cursor-pointer appearance-none opacity-0 absolute z-10 inset-0 w-full h-full block"
          }
        )
      ]
    }
  );
}
const G = "id-8ae00f79-601c-4e52-9769-366284da3e72-style";
function te() {
  if (document.getElementById(G))
    return;
  document.documentElement.style.overflowY = "scroll";
  const n = document.createElement("style");
  n.id = G, n.innerHTML = `:root { --global-scrollbar-size: ${window.innerWidth - document.documentElement.offsetWidth}px; }`, document.documentElement.style.overflowY = "", document.head.appendChild(n);
}
function De() {
  te();
}
const ae = {
  pageInfo: ({ firstItemNumber: n, lastItemNumber: t, total: i }) => /* @__PURE__ */ k(P, { type: "Body/M/Book", children: [
    "Showing",
    " ",
    /* @__PURE__ */ k(P, { type: "Body/M/Bold", children: [
      n,
      "-",
      t
    ] }),
    " ",
    "of ",
    i,
    " items"
  ] })
};
function Pe({
  total: n,
  skip: t,
  take: i,
  onChange: h,
  i18n: u,
  className: m,
  innerRef: r,
  style: C
}) {
  const S = K({ fallback: ae, overrides: u }), {
    pageCount: a,
    pageIndex: g,
    skipForNextPage: e,
    skipForPage: d,
    skipForPrevPage: s,
    isLastPage: l,
    isFirstPage: c
  } = U({
    total: n,
    skip: t,
    take: i
  }), f = T(
    () => Q(0, a).map((b) => ({ label: String(b + 1), value: b })).toArray(),
    [a]
  );
  return /* @__PURE__ */ k("div", { ref: r, className: D("flex items-center", m), style: C, children: [
    /* @__PURE__ */ o("div", { className: "pr-6", children: S.pageInfo({
      firstItemNumber: t + 1,
      lastItemNumber: Math.min(n, t + i),
      total: n
    }) }),
    /* @__PURE__ */ k("div", { className: "flex items-center gap-1 pr-2", children: [
      /* @__PURE__ */ o(
        E,
        {
          disabled: c,
          icon: "Left",
          onClick: () => h?.(s())
        }
      ),
      /* @__PURE__ */ o(
        V,
        {
          style: { minWidth: 60 },
          options: f,
          value: g,
          onChange: (b) => b != null && h?.(d(b))
        }
      ),
      /* @__PURE__ */ o(
        E,
        {
          disabled: l,
          icon: "Right",
          onClick: () => h?.(e())
        }
      )
    ] }),
    /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(P, { type: "Body/M/Book", children: `/${a}` }) })
  ] });
}
const H = "checkbox-77edc535-41bd-42ad-8358-dedc992586ce";
function we({
  rows: n,
  selectBy: t,
  filteredRows: i = n,
  multiSelectCtx: h,
  selectableRowIds: u,
  mode: m = "checkbox",
  alwaysSelected: r,
  dataAttributes: C
}) {
  const S = L({
    alwaysSelected: r,
    selectable: u ?? n.map(t)
  }), a = h ?? S, g = T(
    () => i.map((d) => t(d)),
    [i, t]
  ), e = T(
    () => u ? v(g).intersect(u) : v(g),
    [g, u]
  );
  return T(() => {
    const d = (s) => {
      const l = a.selection?.has(s);
      m === "checkbox" ? a.toggle(s, !l) : l ? a.setSelection([]) : a.setSelection([s]);
    };
    return {
      toggle: d,
      multiSelectCtx: a,
      column: {
        name: H,
        header: (s) => {
          const l = a.selection.size > 0 && e.intersect(a.selection).size === e.size, c = a.selection.size > 0 && !l, f = () => {
            c || e.intersect(a.selection).size === e.intersect(a.alwaysSelected).size ? a.setSelection(a.selection.union(e)) : a.setSelection(a.selection.subtract(e));
          }, b = m === "radio";
          return /* @__PURE__ */ o(
            I,
            {
              style: s.style,
              className: s.className,
              innerRef: s.innerRef,
              title: s.title,
              alignItems: "center",
              justifyContent: "center",
              onClick: (p) => {
                p.stopPropagation(), b || f();
              },
              children: /* @__PURE__ */ o(
                N,
                {
                  onClick: (p) => p.stopPropagation(),
                  checked: c ? "indeterminate" : l,
                  disabled: b,
                  onChange: f,
                  ...C?.header ?? z
                }
              )
            }
          );
        },
        content: (s, l) => {
          const c = t(s), f = a.selection.has(c), b = a.disabled(c);
          return /* @__PURE__ */ o(
            I,
            {
              style: l.style,
              className: l.className,
              innerRef: l.innerRef,
              title: l.title,
              alignItems: "center",
              justifyContent: "center",
              onClick: (p) => {
                p.stopPropagation(), b || d(c);
              },
              children: /* @__PURE__ */ o(
                N,
                {
                  onClick: (p) => p.stopPropagation(),
                  checked: f,
                  disabled: b,
                  onChange: () => d(c),
                  ...C?.rows?.(s) ?? z
                }
              )
            }
          );
        },
        width: 32,
        minWidth: 32,
        maxWidth: 32
      },
      rowClassName: (s) => ({
        "transition-colors": !0,
        "bg-[#EDF7F5]!": a.selection.has(t(s)),
        "cursor-auto!": a.disabled(t(s))
      })
    };
  }, [C, e, m, a, t]);
}
function Me({
  groupedRows: n,
  selectBy: t,
  filteredGroupedRows: i = n,
  multiSelectCtx: h,
  selectableRowIds: u,
  mode: m = "checkbox",
  alwaysSelected: r
}) {
  const C = T(
    () => n.flatMap((d) => d.rows).map(t),
    [n, t]
  ), S = T(
    () => i.flatMap((d) => d.rows).map(t),
    [i, t]
  ), a = T(
    () => u ? v(S).intersect(u) : v(S),
    [S, u]
  ), g = L({
    alwaysSelected: r,
    selectable: u ?? C
  }), e = h ?? g;
  return T(() => {
    const d = (s) => {
      const l = e.selection?.has(s);
      m === "checkbox" ? e.toggle(s, !l) : l ? e.setSelection([]) : e.setSelection([s]);
    };
    return {
      toggle: d,
      multiSelectCtx: e,
      column: {
        name: H,
        header: (s) => {
          const l = e.selection.size > 0 && a.intersect(e.selection).size === a.size, c = e.selection.size > 0 && !l, f = () => {
            c || a.intersect(e.selection).size === a.intersect(e.alwaysSelected).size ? e.setSelection(e.selection.union(a)) : e.setSelection(e.selection.subtract(a));
          }, b = m === "radio";
          return /* @__PURE__ */ o(
            I,
            {
              style: s.style,
              className: s.className,
              innerRef: s.innerRef,
              title: s.title,
              alignItems: "center",
              justifyContent: "center",
              onClick: (p) => {
                p.stopPropagation(), b || f();
              },
              children: /* @__PURE__ */ o(
                N,
                {
                  onClick: (p) => p.stopPropagation(),
                  checked: c ? "indeterminate" : l,
                  disabled: b,
                  onChange: f
                }
              )
            }
          );
        },
        groupContent: (s, l) => {
          const c = v(s.rows.map(t)), f = e.selection.intersect(c), b = e.selectable?.intersect(c), p = f.size > 0 && f.size === (b?.size ?? c.size), w = f.size > 0 && !p, M = () => {
            w || f.size === e.alwaysSelected.intersect(c).size ? e.setSelection(e.selection.union(c)) : e.setSelection(e.selection.subtract(c));
          }, R = m === "radio" || c.size === 0 || c.every((B) => e.disabled(B));
          return /* @__PURE__ */ o(
            I,
            {
              style: l.style,
              className: l.className,
              innerRef: l.innerRef,
              title: l.title,
              alignItems: "center",
              justifyContent: "center",
              onClick: (B) => {
                B.stopPropagation(), R || M();
              },
              children: /* @__PURE__ */ o(
                N,
                {
                  onClick: (B) => B.stopPropagation(),
                  checked: w ? "indeterminate" : p,
                  disabled: R,
                  onChange: M
                }
              )
            }
          );
        },
        content: (s, l) => {
          const c = t(s), f = e.selection.has(c), b = e.disabled(c);
          return /* @__PURE__ */ o(
            I,
            {
              style: l.style,
              className: l.className,
              innerRef: l.innerRef,
              title: l.title,
              alignItems: "center",
              justifyContent: "center",
              onClick: (p) => {
                p.stopPropagation(), b || d(c);
              },
              children: /* @__PURE__ */ o(
                N,
                {
                  onClick: (p) => p.stopPropagation(),
                  checked: f,
                  disabled: b,
                  onChange: () => d(c)
                }
              )
            }
          );
        },
        width: 32,
        minWidth: 32,
        maxWidth: 32
      },
      rowClassName: (s) => ({
        "transition-colors": !0,
        "bg-[#EDF7F5]!": e.selection.has(t(s)),
        "cursor-auto!": e.disabled(t(s))
      })
    };
  }, [e, m, a, t]);
}
export {
  Fe as ActionText,
  Ee as AsyncLinkButton,
  ze as AutoSortHScrollTable,
  Ge as AutoSortHScrollTableWithGroups,
  Le as AutoSortTable,
  He as AutoSortTableWithGroups,
  j as AutoTooltip,
  Ae as AutoTooltipBare,
  ke as Badge,
  je as Banner,
  Oe as BaseHScrollTable,
  Ye as BaseHScrollTableWithGroups,
  $e as BaseTable,
  qe as BaseTableWithGroups,
  Ke as ButtonGroup,
  Ue as ButtonGroupRadio,
  Ve as Calendar,
  Je as CircularProgressBar,
  Qe as CircularProgressBarBare,
  ve as ClickableArea,
  Xe as ClickableDiv,
  Ze as Collapsible,
  _e as CollapsibleBase,
  et as Column,
  tt as ComputedSizeContainer,
  at as ContentShadow,
  st as Controller,
  nt as DatePickerRangeInput,
  lt as DebouncedSearchInput,
  ot as DefaultCollapsibleContent,
  it as DefaultCollapsibleHeader,
  rt as DefaultTabIndicator,
  ct as DefaultTabTitle,
  dt as DefaultTabTitleBare,
  ut as Dialog,
  mt as DialogBox,
  bt as DialogFooter,
  pt as DialogHeader,
  ht as DraggableList,
  ft as DropdownMenu,
  gt as DropdownMenuActionButton,
  Ct as DropdownMenuBase,
  Be as ErrorBoundary,
  St as FlexBox,
  yt as FloatingContent,
  Tt as FloatingContext,
  O as Icon,
  Ie as IconTooltip,
  xt as LinkButton,
  kt as LoadingLinkButton,
  ee as LocalOverlay,
  Bt as Modal,
  It as MultiSlider,
  Nt as MultiSliderBare,
  vt as MultiSliderInner,
  Dt as NestedTransition,
  Pt as NestedTransitionBare,
  Ne as Overlay,
  Pe as Pagination,
  wt as ProgressBar,
  Mt as ProgressBarBare,
  I as Row,
  Rt as ScrollWrapper,
  Wt as ScrollWrapperBare,
  Ft as ScrollWrapperEndShadow,
  Et as ScrollWrapperEndShadowBare,
  zt as ScrollWrapperStartShadow,
  Gt as ScrollWrapperStartShadowBare,
  Lt as Searchable,
  Ht as Shadows,
  At as Slider,
  jt as SliderBare,
  Ot as SliderInput,
  Yt as SliderInputBare,
  F as StackingContext,
  $t as StickyShadows,
  qt as Svg,
  Kt as SvgBare,
  Ut as Tab,
  Vt as TabBare,
  Jt as TabGroup,
  Qt as TabGroupBare,
  Xt as TabGroupContext,
  Zt as TableDataCell,
  _t as TableDataRow,
  ea as TableFooter,
  ta as TableFooterCell,
  aa as TableGroupDataCell,
  sa as TableHead,
  na as TableHeadCell,
  la as TableHeadCellWithDropdown,
  oa as TableRow,
  ia as TableWithGroupsDataRow,
  P as Text,
  ra as TextType,
  ca as Tooltip,
  da as TooltipCloseButton,
  ua as TooltipContent,
  ma as TooltipContext,
  ba as TooltipInner,
  Y as Transition,
  pa as TransitionBare,
  ha as TransitionContext,
  fa as TreeView,
  ga as classListFromTransitionStatus,
  W as colorBySeverity,
  Z as defaultBadgeClassName,
  Ca as defaultBannerI18n,
  Sa as defaultButtonGroupClassName,
  ya as defaultColumnHPadding,
  Ta as defaultContentTextType,
  xa as defaultDatePickerRangeInputI18n,
  ka as defaultDialogBoxI18n,
  Ba as defaultFloatingContentI18n,
  Ia as defaultGroupContentTextType,
  Na as defaultHandleBorder,
  va as defaultHandleInnerRadius,
  Da as defaultIconSet,
  Pa as defaultModalI18n,
  ae as defaultPaginationI18n,
  wa as defaultRowHeight,
  Ma as defaultRowKey,
  Ra as defaultTailwindTransitionDurationMs,
  Wa as floatingContentAlignments,
  Fa as floatingContentPositions,
  Ea as getRenderedData,
  za as getTopLeftDefault,
  De as initMDOTUI,
  Ga as isIconName,
  U as makePaginationHelper,
  La as mergeI18n,
  Ha as messageSeverities,
  Aa as sortRows,
  ja as styleFromTransitionStatus,
  Oa as svgNameSpace,
  Ya as textDataAttr,
  $a as updateOrderBy,
  qa as useListbox,
  K as useMergeI18n,
  Ka as usePulse,
  Ua as useScrollWrapper,
  we as useSelectableTableColumn,
  Me as useSelectableTableWithGroupColumn,
  Va as useSortedRows,
  Ja as useTableWithGroupColumns,
  Qa as useTransition,
  Xa as useTransitionStatus
};
//# sourceMappingURL=index.js.map
